module.exports = __webpack_public_path__ + "static/media/Pamela Ricco Headshot.0777f874.jpeg";